// extracted by mini-css-extract-plugin
module.exports =  {"scroll":"_0bc5e8de02--scroll--wJQwT","image":"_0bc5e8de02--image--Ft_Fk","image-inner":"_0bc5e8de02--image-inner--t60xu"};